import React, { useContext } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Button, Col, Row } from "components/bootstrap";
import InputProfileSelectionList from "./InputProfileSelectionList";
import InputProfileHelpPanel from "./InputProfileHelpPanel";
import { StyledSection, StyledTitle } from "../StyledWizardComponents";
import { ForwarderWizardContext } from "../ForwarderWizardProvider";
const StyledHelpComponent = styled.div`
  margin-top: 30px;
`;
const SelectInputProfile = ({ onCreateInputProfileClick, onInputProfileSelect }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { selectedForwarder } = useContext(ForwarderWizardContext);
  if (!selectedForwarder) {
    return /* @__PURE__ */ React.createElement("div", null, t("select_input_profile.select_forwarder_first"));
  }
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(StyledTitle, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "select_input_profile.heading",
      values: { title: selectedForwarder.title },
      components: { em: /* @__PURE__ */ React.createElement("em", null) }
    }
  )), /* @__PURE__ */ React.createElement(StyledSection, null, /* @__PURE__ */ React.createElement("p", null, t("select_input_profile.intro")), /* @__PURE__ */ React.createElement("p", null, t("select_input_profile.create_question")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onCreateInputProfileClick }, t("select_input_profile.create_button"))), /* @__PURE__ */ React.createElement(StyledSection, null, /* @__PURE__ */ React.createElement("p", null, t("select_input_profile.select_existing")), /* @__PURE__ */ React.createElement(InputProfileSelectionList, { onInputProfileSelect }))), /* @__PURE__ */ React.createElement(Col, { md: 4, mdOffset: 1 }, /* @__PURE__ */ React.createElement(StyledHelpComponent, null, /* @__PURE__ */ React.createElement(InputProfileHelpPanel, null))));
};
export default SelectInputProfile;
